var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipAccessDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.21 1.5 12C1.5 17.79 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM10.25 17.25C10.25 17.48 10.16 17.7 9.99 17.87C9.82 18.04 9.6 18.13 9.37 18.13H6.75C6.52 18.13 6.3 18.04 6.13 17.87C5.96 17.7 5.87 17.48 5.87 17.25V12C5.87 11.77 5.96 11.55 6.13 11.38C6.3 11.21 6.52 11.12 6.75 11.12H9.37C9.6 11.12 9.82 11.21 9.99 11.38C10.16 11.55 10.25 11.77 10.25 12V17.25ZM18.12 13.75C18.12 13.98 18.03 14.2 17.86 14.37C17.69 14.54 17.47 14.63 17.24 14.63H12.86V16.38H15.05V17.26H11.11V16.38H11.99V14.63H11.11V13.75H17.23V7.63H7.62V10.25H6.74V7.63C6.74 7.4 6.83 7.18 7 7.01C7.17 6.84 7.39 6.75 7.62 6.75H17.24C17.47 6.75 17.69 6.84 17.86 7.01C18.03 7.18 18.12 7.4 18.12 7.63V13.75Z",
    fill: "#99A1AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipAccessDevices);
export default __webpack_public_path__ + "static/media/ic-chip-access-devices.ce61b00c10a7c0573ed8013a91ee3d83.svg";
export { ForwardRef as ReactComponent };